/**
 * Session breadcrumb disambiguation (SessionBar, BrainstormyLayout.jsx).
 * Display-only — never touches the stored name.
 *
 * When two or more siblings (same parent, same level: projects among
 * projects, stories within a project, sessions within a story/project)
 * share the exact same name, the first-created one renders plain and each
 * later one gets " (N)" appended, N = its 1-based creation-order rank among
 * the same-named siblings — e.g. "Midnight Garden", "Midnight Garden (2)".
 * A name that's unique among its siblings is returned unchanged.
 */
export function disambiguateName(entity, siblings) {
  if (!entity || !entity.name) return entity?.name || '';

  const sameName = (siblings || []).filter((s) => s && s.name === entity.name);
  if (sameName.length <= 1) return entity.name;

  const sorted = [...sameName].sort((a, b) => {
    const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
    const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
    return ta - tb;
  });
  const rank = sorted.findIndex((s) => s.id === entity.id) + 1;

  // Not found among siblings (e.g. a fetch race) — nothing to safely rank
  // against, so render plain rather than guess.
  return rank <= 1 ? entity.name : `${entity.name} (${rank})`;
}
